// extracted by mini-css-extract-plugin
export default {"main_container":"CountryList_main_container__LFHiu","back_arrow":"CountryList_back_arrow__GEM7c","heading":"CountryList_heading__6a4BU","full_name":"CountryList_full_name__DpY8M"};